import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { JiraConnector } from '../../connector';

export const JiraService = IntegrationService.make({
  connector: JiraConnector,
  name: Integration_Service_Names_Enum.Jira,
});
